import React, {PropTypes} from 'react';
function AssessmentBenefits(props) {
  const {
    style: {
      color,
      backgroundColor
    } = {}
  } = props;

  return (
    <svg width="89px" height="69px" viewBox="0 0 89 69" version="1.1" >

      <title>9948A670-D278-4B0A-99FA-229BF88B8883</title>
      <desc>Created with sketchtool.</desc>
      <defs></defs>
      <g id="501---Assesments" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-334.000000, -670.000000)" id="Group-22" fill="#333333">
          <g transform="translate(278.000000, 622.000000)">
            <g id="Group-4" transform="translate(56.000000, 48.000000)">
              <g id="icon_nurse-copy" >
                <g id="Icons">
                  <g id="Group">
                    {/* eslint-disable-next-line max-len */}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M275.2 250.5c6.998 7.377 18.5 7.377 25.5 0l108.1-114.2c31.49-33.13 29.72-88.22-5.65-118.7c-35.37-30.63-81.38-16.91-104.9 7.724L287.1 36.91L276.8 25.28C253.9 1.149 207.6-13.45 171.1 17.56C136.7 48.06 134.7 103.1 166.4 136.3L275.2 250.5zM192.3 41.79C213.2 23.79 240.6 33.17 254.2 47.54l33.74 35.26l33.74-35.26c13.5-14.13 40.99-23.76 61.86-5.752c23.74 20.63 20.12 54.51 3.373 72.14L287.9 217.7L188.1 113.9C172.2 96.56 168.7 62.42 192.3 41.79zM558.2 333.6c-9.5-8.619-22-13.37-35.12-13.37c-12.5 0-24.88 4.248-34.62 12.12l-61.45 49.21c-1.928 1.545-4.324 2.385-6.795 2.385h-41.62c4.625-9.619 6.5-20.74 4.75-32.23C379.4 323.7 353.7 304 325.6 304H181.2c-20.75 0-40.1 6.746-57.5 19.24l-38.5 28.73H16c-8.801 0-16 7.195-16 15.99s7.198 16.04 15.1 16.04l80.01 .0091l46.86-35.29c11.12-8.244 24.62-12.74 38.37-12.74h146.7c13.25 0 24 10.74 24 23.99s-10.75 23.98-24 23.98H239.1c-8.75 0-16 7.246-16 15.99c0 8.746 7.25 15.99 16 15.99h180.2c9.625 0 19-3.248 26.62-9.246l61.62-49.22c4.25-3.373 9.5-5.248 14.62-5.248c5 0 9.875 1.75 13.75 5.248c10.12 9.119 9.375 24.48-.875 32.61l-100.7 80.58c-7.584 6.064-17.01 9.369-26.72 9.369H16c-8.801 0-15.1 7.189-15.1 15.98S7.198 512 15.1 512h392.5c17 0 33.38-5.871 46.62-16.37l100.9-80.7c12.25-9.744 19.5-24.36 19.1-39.98C576.5 359.3 569.1 344.2 558.2 333.6z"/></svg>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

AssessmentBenefits.propTypes = {
  style: PropTypes.object
};

export default AssessmentBenefits;



// WEBPACK FOOTER //
// ./shared/common/svgs/AssessmentBenefits.js